import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadWeightLocationDto } from '../../api/models';

export type TABLE_TYPE = Table<HeadWeightLocationDto>;

export const TABLE = 'headWeightLocation';
const SCHEMA = 'headWeightLocationId';

class HeadWeightLocationDatabase implements DataRepository<HeadWeightLocationDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  // common methods:
  get(key: Key): Promise<HeadWeightLocationDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadWeightLocationDto, key: Key): Promise<HeadWeightLocationDto> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadWeightLocationDto[]): Promise<HeadWeightLocationDto[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadWeightLocationDto[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadWeightLocationDB = new HeadWeightLocationDatabase(db);
